import { type FC } from "react";
import { useTranslation } from "react-i18next";
import CompactDialog from "../../../../components/CompactDialog";

interface RejectSymbolDialogProps {
  open: boolean;
  createdBy: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const RejectSymbolDialog: FC<RejectSymbolDialogProps> = ({ open, createdBy, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  return (
    <CompactDialog
      open={open}
      title={t("configuration.ingenieurslegende.rejectSymbol")}
      message={t("configuration.ingenieurslegende.rejectDialogMessage", { createdBy })}
      confirmText={t("configuration.ingenieurslegende.rejectConfirm")}
      cancelText={t("common.cancel")}
      confirmColor="primary"
      iconColor="error"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default RejectSymbolDialog;
